/**
 * @fileoverview POSTWS handler for the "/:app_group_id/generative_ai/brand_guidelines_evaluation"
 * endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdBrandGuidelinesEvaluation } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationPayload,
  PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationProps,
} from "./types";
import { isPostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationResult } from "./validators";

export const postwsGenerativeAiAppGroupIdBrandGuidelinesEvaluation = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdBrandGuidelinesEvaluation,
  async (
    signal,
    { appGroupId, guidelineId, content, jobToken }: PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationPayload = {
      job_token: jobToken,
      guideline_id: guidelineId,
      content,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/brand_guidelines_evaluation`,
      "POST",
      payload,
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isPostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationResult
);
